/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { decodeToken } from '../utilities/auth';
import { can } from '../utilities/permissionHelpers';
import useOnboardingStore from '../context/onboarding/onboardingStore';
import { useAppContext } from '../context/app/AppProvider';
import { canAccessStorefront } from '../utilities/storefrontAccess';
import { useEnvironmentSwitch } from '../components/hooks/useEnvironmentSwitch';
import { PRE_TEST_RETURN_PATH_KEY } from '../constants/environmentSwitch';

const ProtectedRoute = ({ module, action, allowedModes = ['live', 'test'] }) => {
  const data = decodeToken('da');

  const permissions = useOnboardingStore((state) => state.permissions);
  const { appContext } = useAppContext();
  const { switchTo, merchant } = useEnvironmentSwitch();
  const { merchantDetails } = useOnboardingStore();
  const permissionsLoaded = useOnboardingStore(
    (state) => state.permissionsLoaded
  );
  const businessTier = appContext?.business?.businessTier;
  const isCACRegistered = appContext?.business?.isCACRegisteredBusiness;
  const location = useLocation();

   const isModeBlocked = !allowedModes.includes(appContext?.mode);

const hasCompletedOnboarding =
      appContext.hasCompletedOnboarding;

  const [revertState, setRevertState] = useState('idle');

  useEffect(() => {
    if (isModeBlocked && !hasCompletedOnboarding && revertState === 'idle') {
      setRevertState('reverting');
      let isMounted = true;
      switchTo('live').then(() => {
        if (isMounted) setRevertState('done');
      });
      return () => {
        isMounted = false;
      };
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModeBlocked, hasCompletedOnboarding, revertState]);

  if (!data?.name) {
    return (
      <Navigate to="/login" state={{ path: location.pathname }} replace />
    );
  }

  if (revertState === 'reverting') {
    return null;
  }

  if (revertState === 'done') {
    window.sessionStorage.removeItem(PRE_TEST_RETURN_PATH_KEY);
    return (
      <Navigate
        to="/business-category"
        state={{ isAuthenticated: true, merchant: merchantDetails }}
        replace
      />
    );
  }

  if (isModeBlocked) {
    if (!hasCompletedOnboarding) {
      return null;
    }
    return <Navigate to="/portal" replace />;
  }

  if (module && action && !permissionsLoaded) {
    return null;
  }

  const hasStorefrontAccess = canAccessStorefront(
    isCACRegistered,
    businessTier
  );

  if (module && action && !can(permissions, module, action)) {
    if (module === 'storefront' && hasStorefrontAccess) {
      return <Outlet />;
    }
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
